// 全局弹窗属性

const NAMES = [
    'supplierSettingsProps',
    'shelfPlatformProps',
    'shelfStoreProps',
    'shelfPlatformAndStoreProps',
    'goodsInfoProps',
    'goodsReleaseProps',
    'goodsCategoryProps',
    'groupSalesProps',
    'releaseTemplateProps',
    'batchShelfProps', // 批量上架
    'distributionStrategyProps', // 分销规则
    'previewDetailsProps', // 预览
    'updateOnlineSpuIdsProps', // 多店铺更新线上商品
    'materialImagesProps', // 素材图片选择
    'infoFromOtherShopGoodsDrawerProps' // 店铺商品支持使用本链接快速更新到其他线上店铺商品
]

const buildState = () => {
    return NAMES.reduce((t, c) => {
        Object.assign(t, {
            [c]: {
                visible: false,
                destroyOnClose: true
            }
        })

        return t
    }, {})
}

const createActionName = name => {
    const RRG = /\b(\w)|\s(\w)/g

    return `update${name.replace(RRG, m => m.toUpperCase())}`
}

const buildReducer = () => {
    return NAMES.reduce((t, c) => {
        const actionName = createActionName(c)

        Object.assign(t, {
            [actionName]: (state, { payload }) => {
                return {
                    ...state,
                    [c]: {
                        ...state[c],
                        ...payload
                    }
                }
            }
        })

        return t
    }, {})
}

export default {
    name: 'modal',
    state: {
        ...buildState()
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        },
        ...buildReducer()
    },
    subscriptions: {
        setup({ history, dispatch }) {
            let lastPathname

            const closeAllModal = (names = NAMES) => {
                names.forEach(name => {
                    dispatch({
                        type: createActionName(name),
                        payload: {
                            visible: false
                        }
                    })
                })
            }

            const handler = location => {
                if (location.pathname !== lastPathname) {
                    closeAllModal()
                }

                lastPathname = location.pathname
            }

            history.listen(handler)

            return () => {}
        }
    }
}
